import script from "./SuggestedDrgRequirement.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuggestedDrgRequirement.vue?vue&type=script&lang=ts&setup=true"

import "./SuggestedDrgRequirement.vue?vue&type=style&index=0&id=1794ce0a&lang=scss"

const __exports__ = script;

export default __exports__